import { TokenGenerationStepOneProps } from '../interface/interface';
import SubstituteTokenTable from '../views/SubstituteTokenTable';

export const StepOne = (props: TokenGenerationStepOneProps) => (
  <div>
    <p className="text-primary-blue-500 text-sm mb-3 font-semibold">
      {props.type === 'expiredPrescription'
        ? 'Select the product to create New Prescription'
        : 'Select the substituted product to add substitute token'}
    </p>
    <SubstituteTokenTable
      step={1}
      data={(props.type === 'New Prescription'
        ? props.existingPrescriptionList
        : props.exstingProuductList
      )?.map((x) => ({
        id: x.id,
        productId: x?.product?.id,
        Token: x?.prescription?.token,
        'Product Name': x?.product?.name,
        'Prescribed Qty': x.prescription.prescribedQty,
        'Remaining Repeats': x.prescription.repeatsRemaining,
      }))}
      token={{
        state: props?.selecteToken,
        setter: props?.setSelectToken,
      }}
      substituteToken={{
        state: props?.substituteToken,
        setter: props?.setSubstituteToken,
      }}
    />
  </div>
);
